// src/components/Login.js
import React, { useState } from 'react';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password })
      });

      const data = await response.json();
      if (response.ok && data.success) {
        onLogin?.(data.user);
      } else {
        setError(data.message || 'Login failed.');
      }
    } catch {
      setError('Could not connect to backend.');
    } finally {
      setLoading(false);
    }
  }

  async function handleForgotPassword() {
    const email = prompt('Please enter your registered email:');
    if (!email) return;

    try {
      const res = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      const result = await res.json();
      alert(result.message || 'If your email is registered, a reset link has been sent.');
    } catch {
      alert('Failed to send reset link. Please try again later.');
    }
  }

  return (
    <div style={styles.page}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <h2 style={styles.title}>
          Login to <span style={styles.bold}>TrakieBC</span>
        </h2>

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={styles.input}
          autoComplete="username"
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          autoComplete="current-password"
        />

        <div style={styles.forgotRow}>
          <button type="button" onClick={handleForgotPassword} style={styles.forgotBtn}>
            Forgot Password?
          </button>
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <button type="submit" disabled={loading} style={styles.button}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f4f7fc, #e0eafc)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: "'Segoe UI', sans-serif",
    padding: 20
  },
  form: {
    background: '#ffffff',
    padding: '40px 30px',
    borderRadius: 16,
    boxShadow: '0 10px 25px rgba(0,0,0,0.08)',
    width: '100%',
    maxWidth: 360,
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  title: { marginBottom: 10, fontSize: 22, color: '#0a2348', textAlign: 'center' },
  bold:  { fontWeight: 700 },
  input: {
    padding: '12px 14px',
    fontSize: 15,
    borderRadius: 8,
    border: '1px solid #ccd6dd',
    outline: 'none',
    transition: 'border 0.2s'
  },
  forgotRow: { display: 'flex', justifyContent: 'flex-end', marginTop: -10, marginBottom: -6 },
  forgotBtn: {
    background: 'none',
    border: 'none',
    color: '#0a2348',
    fontSize: '13px',
    cursor: 'pointer',
    textDecoration: 'underline',
    padding: 0
  },
  button: {
    marginTop: 10,
    padding: '12px',
    fontSize: 15,
    borderRadius: 8,
    border: 'none',
    backgroundColor: '#0a2348',
    color: '#ffffff',
    fontWeight: '600',
    cursor: 'pointer'
  },
  error: { color: '#d9534f', fontSize: 13 }
};
